import { Box, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import NameField from './NameField';
import OnPremField from './OnPremField';
import EmailField from './EmailField';
import CustomerDomainField from './CustomerDomainField';
import TenantDomainField from './TenantDomainField';
import type { OrganizationUpdateRequest } from '@/actions/org';

interface GeneralFieldsProps {
  values: OrganizationUpdateRequest;
  setValue: <K extends keyof OrganizationUpdateRequest>(
    key: K,
    value: OrganizationUpdateRequest[K],
  ) => void;
  setChanged: () => void;
  errors: Partial<Record<keyof OrganizationUpdateRequest, string>>;
}

function GeneralFields({
  values,
  setValue,
  setChanged,
  errors,
}: GeneralFieldsProps): React.JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' sx={{ mt: 1 }}>
        General
      </Typography>
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid size={12}>
          <NameField
            value={values.name ?? ''}
            error={errors.name}
            setValue={(v) => {
              setValue('name', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <OnPremField
            value={Boolean(values.on_prem)}
            setValue={(v) => {
              setValue('on_prem', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <EmailField
            value={values.email ?? ''}
            error={errors.email}
            setValue={(v) => {
              setValue('email', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomerDomainField
            value={values.customer_domain ?? ''}
            error={errors.customer_domain}
            setValue={(v) => {
              setValue('customer_domain', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TenantDomainField
            value={values.tenant_domain ?? ''}
            error={errors.tenant_domain}
            setValue={(v) => {
              setValue('tenant_domain', v);
              setChanged();
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default GeneralFields;

